import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

const thfPageBlockedUserContactItemMargin = 16;

@Component({
  selector: 'thf-page-blocked-user-contacts',
  templateUrl: './thf-page-blocked-user-contacts.component.html'
})
export class ThfPageBlockedUserContactsComponent implements AfterViewInit, OnChanges {

  literals: Object;
  overflowItem: boolean = false;

  private mailText: string;
  private phoneText: string;

  @Input('t-email') email: string;

  @Input('t-phone') phone: string;

  @ViewChild('contactGroup', { static: true }) contactGroup: ElementRef;

  @ViewChild('mailItem', { static: true }) mailItem: ElementRef;

  @ViewChild('phoneItem', { static: true }) phoneItem: ElementRef;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.checkContactItemWidth();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.email || changes.phone) {
      this.checkContactItemWidth();
    }
  }

  private checkContactItemWidth() {
    if ( !this.email || !this.phone ) {
      this.overflowItem = true;
      return;
    } else {
      setTimeout(() => {
        const phoneWidth = this.phoneItem.nativeElement.offsetWidth;
        const mailWidth = this.mailItem.nativeElement.offsetWidth;
        const contactGroupHalfWidth = this.contactGroup.nativeElement.offsetWidth / 2;

        this.overflowItem = phoneWidth > contactGroupHalfWidth || mailWidth > contactGroupHalfWidth - thfPageBlockedUserContactItemMargin;
      });
    }
    this.changeDetector.detectChanges();
  }

}
